import { render, staticRenderFns } from "./LeaderboardForm.vue?vue&type=template&id=71590736&scoped=true&"
import script from "./LeaderboardForm.vue?vue&type=script&lang=js&"
export * from "./LeaderboardForm.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardForm.vue?vue&type=style&index=0&id=71590736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71590736",
  null
  
)

export default component.exports